module.exports = __webpack_public_path__ + "media/einstein.fad81b0c.mp3";